import { useLocale } from '../hooks/useLocale'
import LanguageSelector from './LanguageSelector'
import ThemeSelector from './ThemeSelector'
import styles from './Header.module.css'

export default function Header() {
  const { t } = useLocale()

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <a href="#hero" aria-label="Nucelar - Ir a inicio">
            <img src="/nucelar-logo.jpg" alt="Nucelar" className={styles.logoImage} />
          </a>
        </div>
        <nav className={styles.nav} aria-label="Navegación principal">
          <a href="#hero" className={styles.navLink}>
            {t('nav.home')}
          </a>
          <a href="#about" className={styles.navLink}>
            {t('nav.about')}
          </a>
          <a href="#services" className={styles.navLink}>
            {t('nav.services')}
          </a>
          <a href="#expertise" className={styles.navLink}>
            {t('nav.expertise')}
          </a>
          <a href="#contact" className={styles.navLink}>
            {t('nav.contact')}
          </a>
        </nav>
        <div className={styles.controls}>
          <ThemeSelector />
          <LanguageSelector />
        </div>
      </div>
    </header>
  )
}
